import React, { useEffect, useMemo, useState } from 'react'
import { Divider, Button, Popover, List, ListItem, ListItemButton, ListItemText, Chip } from '@mui/material';
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import RestoreIcon from '@mui/icons-material/Restore';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import dayjs from 'dayjs';
import { useSelector, useDispatch } from "react-redux";
import axios from 'axios';
import { CONFIG } from '../../../config';
import FullScreenLoader from '../caller/components/fullscreen-loader';
const API_HOST = CONFIG.modules['accounts'].host

const AddAgent = ({ selectedSlot, shiftAllocationsMap, shiftUsersBySchedules, groups, selectShift, addUserToShift, addUsersToShift, users, shiftUsersBySchedulesMap, attendanceMap, removeUserFromShift, setAnchorElUL, openUL, anchorElUL, campaign, updatingUserInShift }) => {

    // Modify the prop of users to have only the active users
    users = users.filter((u) => u.active);

    const [localShiftUsersBySchedulesMap, setLocalShiftUsersBySchedulesMap] = useState(shiftUsersBySchedulesMap);
    const [overlappingUsers, setOverlappingUsers] = useState([]);

    // Loading State for getting overlapping users;
    const [overlappingUsersLoading, setOverlappingUsersLoading] = useState(false);

    useEffect(() => {
        setLocalShiftUsersBySchedulesMap(shiftUsersBySchedulesMap);
    }, [shiftUsersBySchedulesMap])


    // Create a not in shift users list
    const usersNotInShift = useMemo(() => {
        return users.filter((u) => {
            const telecallerUser = (u.roles || []).includes(process.env.REACT_APP_TELECALLER);

            if (!telecallerUser) {
                return false
            }
            const userInShift = localShiftUsersBySchedulesMap[u._id];
            if (userInShift) {
                return false
            }

            if (overlappingUsers.some(ou => ou._id === u._id)) {
                return false
            }

            return true
        })
    }, [users, localShiftUsersBySchedulesMap, overlappingUsers])

    // Api Method to get users that can be added to the schedule
    /**
     * Need to this because there can be multiple shifts with the same timeslots
     * so need to make sure if an agent in already in a timeslot then has similar timeslot or falls within it
     */
    const getOverlappingUsersInShifts = async () => {
        try {
            setOverlappingUsersLoading(true)
            axios.get(API_HOST + `/overlapping-users-in-shifts?shift=${selectShift._id}&campaign=${campaign}&schedule=${selectedSlot._id}`)
                .then((resp) => {
                    if (resp.data && resp.data.success) {
                        console.log('The users', resp.data.overlappingUsers)
                        setOverlappingUsers(resp.data.overlappingUsers)
                    }
                })
                .catch((e) => {
                    console.log(e)
                }).finally(() => {
                    setOverlappingUsersLoading(false)
                })
        } catch (e) {
            console.log(e, "Error for assigning")
        } finally {

        }
    }

    const {
        map
    } = useSelector((state) => state.user || {});

    useEffect(() => {
        getOverlappingUsersInShifts()
    }, []);

    return (
        <>
            <div>
                <FullScreenLoader open={overlappingUsersLoading} />
                <FullScreenLoader open={updatingUserInShift} />
                <div className="row">
                    <div className="col-md-12">
                        <div className='text-center m-2 p-2'>
                            {
                                selectShift && (
                                    <div>
                                        <h5> {`Agents in ${selectShift.name}`}  (<strong> {`${dayjs(selectShift.start).format("hh:mm:A")}`} </strong>
                                            to  <strong>{`${dayjs(selectShift.end).format("hh:mm:A")}`} </strong>) </h5>
                                    </div>
                                )
                            }
                            {
                                selectedSlot && selectedSlot.from && (
                                    <>


                                        <div className='d-flex align-items-center justify-content-center'>
                                            <CalendarMonthIcon fontSize='sm' /> &nbsp;
                                            <div>
                                                <strong> 	{dayjs(selectedSlot.from).format("DD-MMM-YYYY")} </strong> to  <strong>{dayjs(selectedSlot.to).format("DD-MMM-YYYY")} </strong>
                                            </div>
                                        </div>
                                        <div>
                                            <strong> <ReceiptLongIcon fontSize='sm' /> Capacity : {`${Array.isArray(shiftUsersBySchedules) &&
                                                shiftUsersBySchedules.length > 0 &&
                                                shiftAllocationsMap
                                                ? shiftUsersBySchedules.length *
                                                shiftAllocationsMap[selectShift._id].number
                                                : ""
                                                }`}</strong>
                                        </div>
                                    </>
                                )
                            }

                        </div>
                        <Divider />
                        <div className='mt-3 pt-2'>
                            <div className='text-center'>

                                <Button onClick={(e) => {
                                    setAnchorElUL(e.currentTarget);
                                }}
                                    aria-describedby={"users-list"}
                                >
                                    + Add Agent
                                </Button>

                            </div>
                        </div>

                        <div>
                            <div>
                                {Array.isArray(users) &&
                                    users
                                        .filter((u) => shiftUsersBySchedulesMap[u._id])
                                        .map((u, i) => {
                                            let onLeave = false;
                                            let isOnLeave = false;
                                            let halfDayLeave = false;
                                            let isOnHalfDayLeave = false
                                            let onSwap = false;
                                            let isOnSwap = false
                                            if (i == 0) {
                                                // console.log('The map', attendanceMap)
                                            }
                                            // console.log('a-' + u.name + '-' + u._id, attendanceMap[u._id])
                                            if (
                                                attendanceMap[u._id] &&
                                                attendanceMap[u._id] &&
                                                attendanceMap[u._id].leaveRequest &&
                                                attendanceMap[u._id].swapped
                                            ) {
                                                onSwap = attendanceMap[u._id].leaveRequest;
                                                onSwap.forDate = dayjs(onSwap.forDate).format('YYYY-MM-DD')
                                                console.log('got the leaves', onSwap, selectedSlot)
                                                const checkIfBetween = ((dayjs(onSwap.forDate).isAfter(dayjs(selectedSlot.from)) || dayjs(onSwap.forDate).isSame(dayjs(selectedSlot.from))) && (dayjs(onSwap.forDate).isBefore(dayjs(selectedSlot.to)) || dayjs(onSwap.forDate).isSame(dayjs(selectedSlot.to))))
                                                isOnSwap = checkIfBetween
                                                onSwap.swappedBy = attendanceMap[u._id].swappedBy
                                                onSwap.swappedTo = attendanceMap[u._id].swappedTo
                                            }
                                            if (
                                                attendanceMap[u._id] &&
                                                attendanceMap[u._id].status == "half-day" &&
                                                attendanceMap[u._id] &&
                                                attendanceMap[u._id].leaveRequest
                                            ) {
                                                halfDayLeave = attendanceMap[u._id].leaveRequest;
                                                halfDayLeave.forDate = dayjs(halfDayLeave.forDate).format('YYYY-MM-DD')
                                                console.log('got the leaves', halfDayLeave, selectedSlot)
                                                const checkIfBetween = ((dayjs(halfDayLeave.forDate).isAfter(dayjs(selectedSlot.from)) || dayjs(halfDayLeave.forDate).isSame(dayjs(selectedSlot.from))) && (dayjs(halfDayLeave.forDate).isBefore(dayjs(selectedSlot.to)) || dayjs(halfDayLeave.forDate).isSame(dayjs(selectedSlot.to))))
                                                isOnHalfDayLeave = checkIfBetween
                                            }

                                            if (
                                                attendanceMap[u._id] &&
                                                attendanceMap[u._id].status == "leave" &&
                                                attendanceMap[u._id] &&
                                                attendanceMap[u._id].leaveRequest
                                            ) {
                                                onLeave = attendanceMap[u._id].leaveRequest;
                                                onLeave.from = dayjs(onLeave.from).format('YYYY-MM-DD')
                                                onLeave.to = dayjs(onLeave.to).format('YYYY-MM-DD')
                                                console.log('got the leaves', onLeave, selectedSlot)
                                                const checkIfBetween = ((dayjs(onLeave.from).isAfter(dayjs(selectedSlot.from)) || dayjs(onLeave.from).isSame(dayjs(selectedSlot.from))) && (dayjs(onLeave.to).isBefore(dayjs(selectedSlot.to)) || dayjs(onLeave.to).isSame(dayjs(selectedSlot.to))))
                                                const left = ((dayjs(onLeave.from).isBefore(dayjs(selectedSlot.from)) || dayjs(onLeave.from).isSame(dayjs(selectedSlot.from))) && (dayjs(onLeave.to).isBefore(dayjs(selectedSlot.to)) || dayjs(onLeave.to).isSame(dayjs(selectedSlot.to))))
                                                const right = ((dayjs(onLeave.from).isAfter(dayjs(selectedSlot.from)) || dayjs(onLeave.from).isSame(dayjs(selectedSlot.from))) && (dayjs(onLeave.to).isAfter(dayjs(selectedSlot.to)) || dayjs(onLeave.to).isSame(dayjs(selectedSlot.to))))
                                                isOnLeave = checkIfBetween || left || right
                                            }
                                            return (
                                                <div className="agent border border-primary rounded m-2 p-2" key={i}>
                                                    {onSwap && (isOnSwap)
                                                        && (
                                                            <Chip
                                                                sx={{ ml: 1 }}
                                                                label={` ${map.users[onSwap.swappedTo || onSwap.swappedBy].name} swapped on (${dayjs(onSwap.forDate).format(
                                                                    "DD/MM/YYYY"
                                                                )})  by`}
                                                                size="small"
                                                                color={"primary"}
                                                                variant="outlined"
                                                            />
                                                        )}
                                                    <strong> {`${i + 1}) ${u.name}`} </strong> ({`${u.uuid}`})
                                                    {onLeave && (isOnLeave)
                                                        && (
                                                            <Chip
                                                                sx={{ ml: 1 }}
                                                                label={`On Leave (${dayjs(onLeave.from).format(
                                                                    "DD/MM/YYYY"
                                                                )}-${dayjs(onLeave.to).format("DD/MM/YYYY")})`}
                                                                size="small"
                                                                color={"error"}
                                                                variant="outlined"
                                                            />
                                                        )}




                                                    {halfDayLeave && (isOnHalfDayLeave)
                                                        && (
                                                            <Chip
                                                                sx={{ ml: 1 }}
                                                                label={`On Half Day (${dayjs(halfDayLeave.forDate).format(
                                                                    "DD/MM/YYYY"
                                                                )})`}
                                                                size="small"
                                                                color={"warning"}
                                                                variant="outlined"
                                                            />
                                                        )}

                                                    <span className='float-right'><RemoveCircleIcon sx={{ cursor: "pointer" }} onClick={() => {
                                                        removeUserFromShift(
                                                            shiftUsersBySchedulesMap[u._id]._id
                                                        );
                                                    }} /></span>
                                                </div>
                                            );
                                        })}

                            </div>
                        </div>

                        <div className='mt-3 pt-2'>
                            {/* <div className='text-center'>

                            <Button
                                variant='contained'
                            >
                                Save
                            </Button>

                        </div> */}
                        </div>


                        <div className='my-4'>
                            <Divider />
                        </div>
                        {/* <div className='text-center mt-3'>
                            <Button>
                                Templates
                            </Button>
                        </div>
                        <div className='p-1 text-center'>
                            {
                                (groups || []).map((g, i) => {
                                    return (
                                        <Button variant='outlined' className='m-2' style={{ textTransform: 'none' }} key={i}
                                            onClick={() => {
                                                // console.log(g.members)
                                                addUsersToShift((g.members || []).map(m => m._id))
                                            }}
                                        >
                                            <RestoreIcon /> &nbsp; {g.name} {`(${g.members.length || 0})`}
                                        </Button>
                                    )
                                })
                            }


                        </div> */}

                    </div>
                </div>


            </div>
            <Popover
                id={"users-list"}
                open={openUL}
                anchorEl={anchorElUL}
                onClose={() => setAnchorElUL(null)}
                anchorOrigin={{
                    vertical: "center",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                {/* <List>
                    {Array.isArray(users) &&
                        users
                            .filter((u) =>
                                (u.roles || []).includes(process.env.REACT_APP_TELECALLER)
                            )
                            .filter((u) => {

                                const userInShift = localShiftUsersBySchedulesMap[u._id];
                                console.log('The userInShift', userInShift);
                                if (userInShift) {
                                    return false
                                }
                                return true
                            })
                            .map((u, i) => {
                                console.log('The user', u);
                                return (
                                    <ListItem key={i} disablePadding>
                                        <ListItemButton>
                                            <ListItemText
                                                primaryTypographyProps={{ fontSize: ".8em" }}
                                                primary={`${u.name}`}
                                                onClick={() => {
                                                    addUserToShift(u._id);
                                                }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                );
                            })}
                </List> */}
                <List>
                    {Array.isArray(usersNotInShift) &&
                        usersNotInShift
                            .map((u, i) => {
                                console.log('The user', u);
                                return (
                                    <ListItem key={i} disablePadding>
                                        <ListItemButton>
                                            <ListItemText
                                                primaryTypographyProps={{ fontSize: ".8em" }}
                                                primary={`${u.name}`}
                                                onClick={() => {
                                                    setAnchorElUL(null)
                                                    addUserToShift(u._id);
                                                }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                );
                            })
                    }
                    {
                        usersNotInShift.length == 0 && (
                            <ListItem>
                                <ListItemText
                                    primary="No Telecaller users found"
                                />
                            </ListItem>
                        )
                    }
                </List>
            </Popover>
        </>
    )
}

export default AddAgent;